"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialProtocols = exports.SerialInitModes = exports.SerialCommParameterIds = exports.SerialInterface = exports.WebSerialTransport = exports.MockSerialTransport = exports.SerialTimeoutError = void 0;
var errors_1 = require("./errors");
Object.defineProperty(exports, "SerialTimeoutError", { enumerable: true, get: function () { return errors_1.SerialTimeoutError; } });
var mockSerialTransport_1 = require("./mockSerialTransport");
Object.defineProperty(exports, "MockSerialTransport", { enumerable: true, get: function () { return mockSerialTransport_1.MockSerialTransport; } });
var webSerialTransport_1 = require("./webSerialTransport");
Object.defineProperty(exports, "WebSerialTransport", { enumerable: true, get: function () { return webSerialTransport_1.WebSerialTransport; } });
var SerialInterface_1 = require("./SerialInterface");
Object.defineProperty(exports, "SerialInterface", { enumerable: true, get: function () { return SerialInterface_1.SerialInterface; } });
__exportStar(require("./kdcan"), exports);
var types_1 = require("./types");
Object.defineProperty(exports, "SerialCommParameterIds", { enumerable: true, get: function () { return types_1.SerialCommParameterIds; } });
Object.defineProperty(exports, "SerialInitModes", { enumerable: true, get: function () { return types_1.SerialInitModes; } });
Object.defineProperty(exports, "SerialProtocols", { enumerable: true, get: function () { return types_1.SerialProtocols; } });
// `NodeSerialTransport` lives behind `@emdzej/ediabasx-interface-serial/node`
// so the default browser bundle doesn't try to resolve `serialport` (a
// Node-only native dep). Importing from the main entry is browser-safe.
//# sourceMappingURL=index.js.map